import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

interface FooterLink {
  label: string;
  url: string;
}

interface FooterColumn {
  title: string;
  links: FooterLink[];
}

interface SocialLink {
  name: string;
  icon: string;
  url: string;
}

@Component({
  selector: 'dod-footer',
  standalone: true,
  imports: [CommonModule, TranslocoModule, AccredibleIconComponentModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class DoDFooterComponent {
  public currentYear = new Date().getFullYear();

  public socialLinks: SocialLink[] = [
    { name: 'LinkedIn', icon: 'linkedin', url: 'https://www.linkedin.com/company/accredible' },
    { name: 'YouTube', icon: 'youtube', url: 'https://www.youtube.com/c/Accredible' },
    { name: 'X', icon: 'x1', url: 'https://twitter.com/accredible?lang=en' },
    { name: 'Facebook', icon: 'facebook', url: 'https://www.facebook.com/Accredible/' },
  ];

  public footerColumns: FooterColumn[] = [
    {
      title: 'platform.title',
      links: [
        { label: 'platform.digital', url: 'https://www.accredible.com/platform' },
        {
          label: 'platform.features',
          url: 'https://www.accredible.com/features',
        },
        {
          label: 'platform.integrations',
          url: 'https://www.accredible.com/services/integrations',
        },
        {
          label: 'platform.managed',
          url: 'https://www.accredible.com/services/managed-integration',
        },
        {
          label: 'platform.professional',
          url: 'https://www.accredible.com/services/professional-services',
        },
        { label: 'platform.pricing', url: 'https://www.accredible.com/pricing' },
      ],
    },
    {
      title: 'solutions.title',
      links: [
        {
          label: 'solutions.product',
          url: 'https://www.accredible.com/solutions/product-certification',
        },
        {
          label: 'solutions.associations',
          url: 'https://www.accredible.com/solutions/associations',
        },
        {
          label: 'solutions.higherEd',
          url: 'https://www.accredible.com/solutions/higher-education',
        },
        {
          label: 'solutions.online',
          url: 'https://www.accredible.com/solutions/online-learning-platforms',
        },
        {
          label: 'solutions.employee',
          url: 'https://www.accredible.com/solutions/employee-training',
        },
        {
          label: 'solutions.awarding',
          url: 'https://www.accredible.com/solutions/testing-awarding-bodies',
        },
      ],
    },
    {
      title: 'resources.title',
      links: [
        { label: 'resources.blog', url: 'https://www.accredible.com/blog' },
        { label: 'resources.guides', url: 'https://www.accredible.com/guides' },
        { label: 'resources.events', url: 'https://www.accredible.com/events' },
        {
          label: 'resources.webinars',
          url: 'https://www.accredible.com/webinars',
        },
        {
          label: 'resources.newsletter',
          url: 'https://www.accredible.com/newsletter',
        },
      ],
    },
    {
      title: 'support.title',
      links: [
        {
          label: 'support.help',
          url: 'https://help.accredible.com/s/?language=en_US',
        },
        {
          label: 'support.trust',
          url: 'https://www.accredible.com/trust-center',
        },
        {
          label: 'support.faq',
          url: 'https://www.accredible.com/frequently-asked-questions',
        },
        { label: 'support.status', url: 'https://status.accredible.com/' },
        { label: 'support.api', url: 'https://docs.api.accredible.com/' },
        {
          label: 'support.contact',
          url: 'https://www.accredible.com/contact-us',
        },
      ],
    },
    {
      title: 'company.title',
      links: [
        { label: 'company.about', url: 'https://www.accredible.com/about' },
        { label: 'company.careers', url: 'https://www.accredible.com/careers' },
        {
          label: 'company.customers',
          url: 'https://www.accredible.com/customers',
        },
        { label: 'company.newsroom', url: 'https://www.accredible.com/newsroom' },
        {
          label: 'company.partner',
          url: 'https://www.accredible.com/partnerships',
        },
      ],
    },
  ];

  public legalLinks: FooterLink[] = [
    {
      label: 'legal.privacy',
      url: 'https://www.accredible.com/legal/privacy-policy',
    },
    {
      label: 'legal.accessibility',
      url: 'https://help.accredible.com/s/article/accessibility',
    },
    {
      label: 'legal.terms',
      url: 'https://www.accredible.com/legal/terms-of-service',
    },
  ];
}
